import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import PostAddIcon from "@mui/icons-material/PostAdd";
import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";

import Confirm from "../../components/Confirm";
import CustomCourseItem from "./CustomCourseItem";

import { getCustomCourses, updateCustomCourse, deleteCustomCourseById, getCompanyCourses } from "../../api/courses";

const CustomCoursesTable = ({ match, history }) => {
  const { t } = useTranslation();
  const { crewId } = match.params;
  const [courses, setCourses] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [refresh, setRefresh] = useState(1);

  function showDeleteModal(id) {
    setSelectedCourseId(id);
    setIsDeleteModalShow(true);
  }

  function onEdit(id) {
    history.push(`${match.url}/edit/${id}`);
  }
  async function onStatusChange(id, newStatus) {
    await updateCustomCourse(id, { status: newStatus });

    setRefresh(refresh * -1);
  }

  async function confirmDeleteModal(isConfirmed) {
    if (isConfirmed) {
      await deleteCustomCourseById(selectedCourseId);
    }
    setIsDeleteModalShow(false);

    setRefresh(refresh * -1);
  }

  useEffect(() => {
    (async () => {
      if (crewId) {
        const companyCourses = await getCompanyCourses(crewId);
        setCourses(companyCourses);
      } else {
        const newCourses = await getCustomCourses();
        setCourses(newCourses);
      }
    })();
  }, [crewId, refresh]);

  return (
    <>
      <h2>{t("custom_courses.title")}</h2>
      <TableComponent
        TopComponent={
          <Button size="small" onClick={() => history.replace(`${match.url}/add`)}>
            <PostAddIcon />
            {t("custom_courses.add_new_certificate")}
          </Button>
        }
        header={[
          { title: t("id"), sort: "id", style: { width: "5%" } },
          {
            title: t("custom_courses.certificate_full_name"),
            sort: "displayName",
            style: { width: "50%" },
          },
          { title: t("certificate.validity_period"), sort: "validPeriod" },
          { title: t("table_headers.theme"), sort: "courseCategory" },
          { title: t("status"), sort: "status" },
          { title: t("actions") },
        ]}
        renderChildren={(course) => (
          <CustomCourseItem
            key={course.id}
            onEdit={onEdit}
            onDelete={showDeleteModal}
            onStatusChange={onStatusChange}
            course={course}
          />
        )}
        items={courses}
        search={["name", "id"]}
        pagination
      />
      {isDeleteModalShow && selectedCourseId ? (
        <Confirm title={t("custom_courses.delete_certificate")} onConfirm={confirmDeleteModal}>
          <p>{t("custom_courses.delete_confirm")}</p>
        </Confirm>
      ) : null}
    </>
  );
};

export default CustomCoursesTable;
